export const labelText_style = {
  labelSx: {
    fontSize: 12,
    textAlign: 'left',
    letterSpacing: 0,
    textTransform: 'capitalize',
    color: 'text.label',
  },
};
